"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _reactRedux = require("react-redux");

var _actions = require("../../../../redux/locations/actions");

var _selectors = require("../../../../redux/locations/selectors");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DetailsMap = function DetailsMap(_ref) {
  var location = _ref.location;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      lastPageViewId = _useSearchSelector.lastPageViewId;

  var center = {
    lat: location.latitude,
    lng: location.longitude
  };
  var markerIcon = "https://firebasestorage.googleapis.com/v0/b/infusion-center-locator.appspot.com/o/attribute_icons%252Fimg-map-pin.png?alt=media";
  var markers = "icon:".concat(markerIcon, "|").concat(center.lat, ",").concat(center.lng);
  var imgSrc = "https://maps.googleapis.com/maps/api/staticmap?markers=".concat(markers, "&size=640x320&key=AIzaSyCSvWkVdrGsFpOsrnvCLVFZWpGgtGbrVRw");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "details-map-container relative h100",
    style: {
      backgroundImage: "url(".concat(imgSrc, ")")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-map-overlay"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-map-gradient flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-map-address bodyFont flex1 marginLeft25"
  }, /*#__PURE__*/_react.default.createElement("div", null, location.address.line1), /*#__PURE__*/_react.default.createElement("div", null, location.address.line2), /*#__PURE__*/_react.default.createElement("div", null, location.address.city, ", ", location.address.stateCode, " ", location.address.zip)), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex1 marginRight25 justify-end details-map-get-directions"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "outlined",
    onClick: function onClick() {
      dispatch((0, _actions.trackLocationClick)(location.id, "directions_clicks", lastPageViewId));
      window.open("https://maps.google.com?saddr=Current+Location&daddr=".concat(center.lat, ",").concat(center.lng), "_target=blank");
    }
  }, "Get Directions")))));
};

var _default = DetailsMap;
exports.default = _default;